import { Spinner } from '@/components/glitch-ui/spinner';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface ConfirmationModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  triggerDialogText?: string;
  isLoading?: boolean;
  loadingText?: string;
  variant?: 'destructive' | 'warning';
}

export function ConformationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = 'Continue',
  cancelText = 'Cancel',
  triggerDialogText,
  isLoading = false,
  loadingText,
  variant = 'destructive',
}: ConfirmationModalProps) {
  const confirmClassName = variant === 'warning'
    ? 'bg-[#FEF3C7] hover:bg-[#FDEDB5] text-[#A16207] border border-[#FDE68A] shadow-none'
    : 'bg-[#B91C1C] hover:bg-[#991B1B] text-white border-none shadow-sm';
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => { if (!open) onClose?.(); }}>
      {triggerDialogText && (
        <AlertDialogTrigger asChild>
          <Button variant='outline'>{triggerDialogText}</Button>
        </AlertDialogTrigger>
      )}
      <AlertDialogContent onKeyDown={(e) => { if (e.key === 'Enter' && !isLoading && !(e.target instanceof HTMLButtonElement)) { e.preventDefault(); onConfirm(); } }}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose} disabled={isLoading}>{cancelText}</AlertDialogCancel>
          <Button onClick={onConfirm} disabled={isLoading} className={confirmClassName}>
            {isLoading ? (
              <>
                <Spinner size="sm" className="mr-2" />
                {loadingText || `${confirmText}...`}
              </>
            ) : (
              confirmText
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
